module.exports = __webpack_public_path__ + "img/sync.c3cb18e1.svg";